/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_newsletter_subscription_success_title = /** @type {(inputs: {}) => string} */ () => {
	return `Vaše registrace byla potvrzena.`
};

const da_newsletter_subscription_success_title = /** @type {(inputs: {}) => string} */ () => {
	return `Din tilmelding er bekræftet.`
};

const de_newsletter_subscription_success_title = /** @type {(inputs: {}) => string} */ () => {
	return `Ihre Anmeldung wurde bestätigt.`
};

const en_newsletter_subscription_success_title = /** @type {(inputs: {}) => string} */ () => {
	return `Your registration has been confirmed.`
};

const es_newsletter_subscription_success_title = /** @type {(inputs: {}) => string} */ () => {
	return `Su suscripción ha sido confirmada.`
};

const fr_newsletter_subscription_success_title = /** @type {(inputs: {}) => string} */ () => {
	return `Votre inscription a bien été confirmée.`
};

const hu_newsletter_subscription_success_title = /** @type {(inputs: {}) => string} */ () => {
	return `Regisztrációja sikeresen megerősítve.`
};

const it_newsletter_subscription_success_title = /** @type {(inputs: {}) => string} */ () => {
	return `La tua iscrizione è stata confermata.`
};

const nl_newsletter_subscription_success_title = /** @type {(inputs: {}) => string} */ () => {
	return `Je inschrijving is bevestigd.`
};

const pl_newsletter_subscription_success_title = /** @type {(inputs: {}) => string} */ () => {
	return `Twoje zapisanie zostało potwierdzone.`
};

const pt_newsletter_subscription_success_title = /** @type {(inputs: {}) => string} */ () => {
	return `A sua inscrição foi confirmada.`
};

const sv_newsletter_subscription_success_title = /** @type {(inputs: {}) => string} */ () => {
	return `Din registrering har bekräftats.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const newsletter_subscription_success_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.newsletter_subscription_success_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("newsletter_subscription_success_title", locale)
	if (locale === "cs") return cs_newsletter_subscription_success_title(inputs)
	if (locale === "da") return da_newsletter_subscription_success_title(inputs)
	if (locale === "de") return de_newsletter_subscription_success_title(inputs)
	if (locale === "en") return en_newsletter_subscription_success_title(inputs)
	if (locale === "es") return es_newsletter_subscription_success_title(inputs)
	if (locale === "fr") return fr_newsletter_subscription_success_title(inputs)
	if (locale === "hu") return hu_newsletter_subscription_success_title(inputs)
	if (locale === "it") return it_newsletter_subscription_success_title(inputs)
	if (locale === "nl") return nl_newsletter_subscription_success_title(inputs)
	if (locale === "pl") return pl_newsletter_subscription_success_title(inputs)
	if (locale === "pt") return pt_newsletter_subscription_success_title(inputs)
	return sv_newsletter_subscription_success_title(inputs)
};
export { newsletter_subscription_success_title as "newsletter.subscription.success.title" }